/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ModuleMetadataLevels } from './moduleMetadataLevels';
import type { ModuleMetadataLearningHours } from './moduleMetadataLearningHours';
import type { ModuleMetadataLanguage } from './moduleMetadataLanguage';
import type { ModuleMetadataEcts } from './moduleMetadataEcts';
import type { ModuleMetadataAutogradeOnSubmission } from './moduleMetadataAutogradeOnSubmission';
import type { ModuleMetadataTaskCompletionPolicy } from './moduleMetadataTaskCompletionPolicy';
import type { ModuleMetadataTaskCompletionMinLevels } from './moduleMetadataTaskCompletionMinLevels';
import type { ModuleMetadataWorkingMode } from './moduleMetadataWorkingMode';
import type { ModuleMetadataExaminationBasis } from './moduleMetadataExaminationBasis';

/**
 * Descriptive properties of a module
 */
export interface ModuleMetadata {
  description?: string;
  levels?: ModuleMetadataLevels;
  learningHours?: ModuleMetadataLearningHours;
  language?: ModuleMetadataLanguage;
  ects?: ModuleMetadataEcts;
  autogradeOnSubmission?: ModuleMetadataAutogradeOnSubmission;
  taskCompletionPolicy?: ModuleMetadataTaskCompletionPolicy;
  taskCompletionMinLevels?: ModuleMetadataTaskCompletionMinLevels;
  workingMode?: ModuleMetadataWorkingMode;
  examinationBasis?: ModuleMetadataExaminationBasis;
}
